<template>
  <div class="mt-0 d-flex flex-column p-0 bg-transparent">
    <datasets-top-controls :facets="facets" :getPage="getPage" :getLimit="getLimit" class="datasets-top-controls"
      ref="sortComponent" @update-sort-type="handleSortType" />
    <div class="container-fluid datasets content">
      <h1 v-if="!useCombinedSearch" class="row col-12 page-title">
        {{ $t('message.search.scopeTitle.combined') }}
      </h1>
      <div class="row">
        <datasets-facets v-if="useDatasetFacets && showFilter"
          class="col-md-3 col-12 mb-3 mb-md-0 px-0 d-none d-md-block" id="datasetFacets" :dataScope="dataScope" />
        <combined-content />
      </div>
      <div class="row">
        <div class="column col-12 col-md-9 offset-md-3">

          <pagination v-if="getSortType !== 'mostLiked'" class="mt-3" :items-count="getDatasetsCount"
            :items-per-page="getLimit" :get-page="getPage" :get-page-count="getPageCount"
            @setPageLimit="setPageLimit" :show-export="true" />
          <pagination v-else class="mt-3" :items-count="getMostLikedTotal" :items-per-page="getLimit"
            :get-page="mostLikedPage" :get-page-count="Math.ceil(getMostLikedTotal / getLimit)"
            :manual-pagination-mode="true" @page-changed="handleMostLikedPageChange" @setPageLimit="setPageLimit" :show-export="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { has, isArray, isNil } from "lodash-es";
import $ from "jquery";
import {
  DatasetsTopControls,
  fileTypes,
  getResponseData
} from "@piveau/piveau-hub-ui-modules";
import DatasetsFacets from "@/components/search/datasets/datasetFacets/DatasetsFacets.vue"
import CombinedContent from "@/components/search/combined/CombinedContent";
import Pagination from "../Pagination";
// import { useStore } from 'vuex';

export default {
  name: "Combined",
  components: {
    CombinedContent,
    DatasetsTopControls,
    DatasetsFacets,
    Pagination,
  },
  metaInfo() {
    return {
      titleTemplate() {
        return this.$t("message.datasets.meta.page.title");
      },
      meta: [
        {
          name: "description",
          vmid: "description",
          content: `${this.$t(
            "message.datasets.meta.description"
          )}`,
        },
        {
          name: "keywords",
          vmid: "keywords",
          content: `${this.$env.keywords} ${this.$t(
            "message.datasets.meta.description"
          )}}`,
        },
        { name: "robots", content: "index, follow" },
      ],
    };
  },
  data() {
    return {
      facetFields: [],
      useDatasetFacets: this.$env.content.datasets.facets.useDatasetFacets,
      useCombinedSearch: this.$env.content.useCombinedSearch,
    };
  },
  computed: {
    ...mapGetters("datasets", [
      "getDatasetsCount",
      "getFacets",
      "getLimit",
      "getSort",
      "getQuery",
      "getDatasetGeoBounds",
      "getPage",
      "getMinScoring",
      "getMaxScoring",
      "getDataServices",
      "getDataScope",
      "getPageCount"
    ]),
    ...mapGetters("search", ["getSortType", 'getMostLikedTotal', 'getSortTriggerId', 'getShowFilter']),
    showCatalogDetails() {
      return !isNil(this.$route.params.ctlg_id);
    },
    showFilter() {
      return this.getShowFilter;
    },
    /**
     * @description Returns the current page.
     * @returns {Number}
     *
     * @deprecated use getPage from datasets store instead
     */
    page() {
      return this.$route.query.page;
    },
    /**
     * @description Returns the active facets.
     * @returns {Object}
     */
    facets() {
      const facets = {};
      for (const rawField of this.facetFields) {
        const field = rawField === "geospatial" ? "source_type" : rawField;
        if (Object.prototype.hasOwnProperty.call(facets, field)) continue;
        let urlFacets;
        if (field === 'catalog' && !isNil(this.$route.params.ctlg_id)) urlFacets = this.$route.params.ctlg_id;
        else urlFacets = this.$route.query[field];
        if (!urlFacets) urlFacets = [];
        else if (!Array.isArray(urlFacets)) urlFacets = [urlFacets];
        facets[field] = urlFacets;
      }
      return facets;
    },
    dataScope() {
      if (!this.$route.query.dataScope) return null;
      if (
        isArray(this.$route.query.dataScope) &&
        this.$route.query.dataScope.length > 0
      )
        return this.$route.query.dataScope[0];
      if (
        isArray(this.$route.query.dataScope) &&
        this.$route.query.dataScope.length === 0
      )
        return null;
      return this.$route.query.dataScope;
    },
    mostLikedPage() {
      return this.$store.state.search.mostLikedPage;
    },
    defaultScoringFacets() {
      return this.$env.content?.datasets?.facets?.scoringFacets?.defaultScoringFacets
    }
  },
  methods: {
    isNil,
    ...mapActions("datasets", [
      "loadDatasets",
      "loadAdditionalDatasets",
      "setPage",
      "setSort",
      "addFacet",
      "setFacets",
      "setFacetOperator",
      "setFacetGroupOperator",
      "setDataServices",
      "setPageCount",
      "setLimit",
      "setDataScope",
      "setDatasetsCount",
      "setAvailableFacets",
      "setDatasets",
      "setMaxScoring"
    ]),
    initMaxScoring() {
      const maxScoring = parseInt(this.$route.query.maxScoring, 10);
      if (maxScoring > 0) this.setMaxScoring(maxScoring);
    },
    ...mapActions('search', ['setEditorialContentItems', 'setEditorialContentCount', 'setDataserviceItems', 'setDataserviceCount', 'setDatasetseriesItems', 'setDatasetseriesCount', 'setCombinedItems', 'setTotalCount']),
    ...mapActions('catalogs', ['setCatalogs', 'setCatalogsCount']),
    isArray,
    initLimit() {
      const limit = parseInt(this.$route.query.limit, 10);
      if (limit > 0) this.setLimit(limit);
    },
    initSort() {
      const sort = this.$route.query.sort;
      if (sort) this.setSort(sort);
    },
    setPageLimit(value) {
      this.setLimit(value);
      if (this.getSortType === "mostLiked") {
        sessionStorage.setItem("mostLikedPage", 1);
        this.$store.commit("search/SET_MOST_LIKED_PAGE", 1);
        this.$store.commit("search/TRIGGER_SORT_RELOAD");
      }
      this.loadData();
    },
    initDataScope() {
      this.setDataScope(this.dataScope);
    },
    /**
     * @description Determines the current page.
     */
    initPage() {
      const page = parseInt(this.$route.query.page, 10);
      if (page > 0) this.setPage(page);
      else this.setPage(1);
    },
    /**
     * Initialize the active facets by checking the route parameters
     */
    initFacets() {
      const fields = this.$env.content.datasets.facets.defaultFacetOrder;
      for (const rawField of fields) {
        const field = rawField === "geospatial" ? "source_type" : rawField;
        if (!this.facetFields.includes(field)) this.facetFields.push(field);
        if (field === 'catalog' && !isNil(this.$route.params.ctlg_id)) {
          this.addFacet({ field, facet: this.$route.params.ctlg_id });
        }
        else if (!Object.prototype.hasOwnProperty.call(this.$route.query, [field])) {
          this.$router
            .replace({
              query: Object.assign({}, this.$route.query, { [field]: [] }),
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          let routeFacets = this.$route.query[field];
          if (!Array.isArray(routeFacets)) routeFacets = [routeFacets];
          for (const facet of routeFacets) {
            // do not add duplicates!
            if (!this.getFacets[field]?.includes(facet)) {

              this.addFacet({ field, facet });
            }
          }
        }
      }
    },
    initFacetOperator() {
      // Always set facet operator to AND when in catalog details mode
      if (this.showCatalogDetails)
        this.setFacetOperator("AND");
      else {
        const op = this.$route.query.facetOperator;
        if (op === "AND" || op === "OR") this.setFacetOperator(op);
      }
    },
    initFacetGroupOperator() {
      // The facetGroupOperator should be the same as the facetOperator
      // Always set facet operator to AND when in catalog details mode
      if (this.showCatalogDetails)
        this.setFacetGroupOperator("AND");
      else {
        const op = this.$route.query.facetOperator;
        if (op === "AND" || op === "OR") this.setFacetGroupOperator(op);
      }
    },
    /**
     * Initialize the active data services facet by checking the route parameters
     */
    initDataServices() {
      const ds = this.$route.query.dataServices;
      if (ds === "true" || ds === "false") this.setDataServices(ds);
      else {
        this.setDataServices("false");
      }
    },
    getFileTypeColor(format) {
      return fileTypes.getFileTypeColor(format);
    },
    handleLikedDatasetsandleSortType(sortType) {
      this.currentSortType = sortType;
    },
    handleMostLikedPageChange(page) {
      if (this.getSortType === "mostLiked") {
        sessionStorage.setItem("mostLikedPage", page);
        this.$store.commit("search/SET_MOST_LIKED_PAGE", page);
        this.$store.commit("search/TRIGGER_SORT_RELOAD");
      }
    },
    assembleNetworkingParams() {
      const activeFacetKeys = Object.keys(this.facets).filter(key => key !== "dataServices" && this.facets[key]?.length);
      const facetsObject = activeFacetKeys.reduce((acc, key) => ({ ...acc, [key]: this.facets[key] }), {});
      const params = {
        filters: "catalogue,dataset,dataservice,datasetseries,resource",
        resource: "editorial-content"
      };
      if (this.getQuery) params.q = this.getQuery;
      if (this.getLimit) params.limit = this.getLimit;
      if (this.getPage) params.page = this.getPage - 1;
      if (this.getSort) params.sort = this.getSort;
      if (this.getDataServices) params.dataServices = this.getDataServices;
      // Add search fields parameter if present in URL
      if (this.$route.query.fields) {
        params.fields = this.$route.query.fields;
      }

      // Date-Parameter nur für die Combined-Suche ("all") hinzufügen
      const dateType = this.$route.query.dateType;
      const minDate = this.$route.query.minDate;
      const maxDate = this.$route.query.maxDate;

      if (dateType) params.dateType = dateType;
      if (minDate) params.minDate = minDate;
      if (maxDate) params.maxDate = maxDate;

      if (this.getDataScope) {
        const dataScope = this.getDataScope;
        params.countryData = dataScope === 'countryData';
        if (params.countryData) {
          if (facetsObject.country) {
            facetsObject.country = facetsObject.country.filter(c => c !== 'countryData');
            if (facetsObject.country.length === 0) {
              delete facetsObject.country;
            }
          }
        } else {
          facetsObject.country = [dataScope];
        }
      }

      if (this.getMinScoring > 0) params.minScoring = this.getMinScoring;
      if (this.getMaxScoring !== undefined && this.getMaxScoring !== null) params.maxScoring = this.getMaxScoring;
      let bounds = this.getDatasetGeoBounds;
      if (bounds instanceof Array && bounds[0] && bounds[1]) {
        bounds = [bounds[0][0], bounds[0][1], bounds[1][0], bounds[1][1]]
        if (bounds.every(bound => parseFloat(bound))) {
          params.bboxMinLat = bounds[0];
          params.bboxMaxLat = bounds[2];
          params.bboxMinLon = bounds[1];
          params.bboxMaxLon = bounds[3];
        }
      }
      if (Object.keys(facetsObject).length) {
        params.facets = JSON.stringify(facetsObject);
      }
      return params;
    },
    transformFetchedFacets(facets) {
      const LEGACY_DATA_SCOPE_FACET_ID = 'dataScope';
      const CORPORATE_BODY_SCOPE_FACET_ID = 'corporate-body-classification';
      const CORPORATE_BODY_NATIONAL_ITEM_ID = '_NATIONAL';
      const activeDataScopeFacetId = this.$env?.content?.datasets?.facets?.dataScopeFacetId || LEGACY_DATA_SCOPE_FACET_ID;
      const normalizeCorporateBodyItemId = (id) => id === '__NATIONAL' ? CORPORATE_BODY_NATIONAL_ITEM_ID : id;
      const transformed = [];
      for (const field of facets) {
        // Check for required field keys
        if (has(field, 'id') && has(field, 'title') && has(field, 'items')) {
          const normalizedFieldId = (field.id === LEGACY_DATA_SCOPE_FACET_ID || field.id === CORPORATE_BODY_SCOPE_FACET_ID)
            ? activeDataScopeFacetId
            : field.id;
          const items = [];
          for (const facet of field.items) {
            const item = {};
            // Check for required facet/item keys
            if (has(facet, 'id') && has(facet, 'title') && has(facet, 'count')) {
              const normalizedFacetId = normalizeCorporateBodyItemId(facet.id);
              item.id = normalizedFacetId;
              item.title = facet.title;
              item.count = facet.count;
              if (has(facet, 'parent_id')) item.parent_id = facet.parent_id;
              else if (has(facet, 'parent_Id')) item.parent_id = facet.parent_Id;
              else if (has(facet, 'parentId')) item.parent_id = facet.parentId;
            }
            // Handle Scoring Facets
            if (has(facet, 'from') && has(facet, 'to')) {
              const currentScoringFacet = this.defaultScoringFacets[facet.id];
              item.minScoring = facet.from;
              item.maxScoring = facet.to;

              // Use config values to overwrite the default values from the backend
              if (currentScoringFacet.title) item.title = currentScoringFacet.title;
              if (currentScoringFacet.minScoring) item.minScoring = currentScoringFacet.minScoring;
              if (currentScoringFacet.maxScoring) item.maxScoring = currentScoringFacet.maxScoring;
            }
            items.push(item);
          }
          if (normalizedFieldId === activeDataScopeFacetId && items.length === 0) {
            continue;
          }
          // Add to response array
          transformed.push({
            id: normalizedFieldId,
            title: field.title,
            items,
          });
        }
      }
      return transformed;
    },
    async loadData() {
      // Set loading state for datasets store to show "loading" message in SearchCount
      this.$store.dispatch('datasets/setLoading', true);
      const baseUrl = this.$env.api.baseUrl;
      const endpoint = "search";
      const queryParams = new URLSearchParams(this.assembleNetworkingParams());
      const requestString = `${baseUrl}${endpoint}?${queryParams}`;
      try {
        const response = await fetch(requestString);
        const data = await response.json();

        const counts = data.result.count;
        this.setDatasetsCount(counts.dataset);
        this.setEditorialContentCount(counts["resource_editorial-content"]);
        this.setDataserviceCount(counts.dataservice);
        this.setDatasetseriesCount(counts.series);
        this.setCatalogsCount(counts.catalogue);
        this.setTotalCount(counts.total);

        this.setAvailableFacets(this.transformFetchedFacets(data.result.facets));

        const combinedResults = data.result.results.map(result => {
          if (result.index === "dataset") {
            result.distributionFormats = (result.distributions ?? []).map(distribution => distribution.format);
          }
          return result;
        });
        this.setCombinedItems(combinedResults);
        const datasetsResult = data.result.results.filter(result => result.index === "dataset");
        this.setDatasets(datasetsResult.map(getResponseData));
        const editorialContentResult = data.result.results.filter(result => result.index === "resource");
        this.setEditorialContentItems(editorialContentResult);
        const catalogsResult = data.result.results.filter(result => result.index === "catalogue");
        this.setCatalogs(catalogsResult);
        const dataServicesResult = data.result.results.filter(result => result.index === "dataservice");
        this.setDataserviceItems(dataServicesResult);
        const datasetseriesResult = data.result.results.filter(result => result.index === "series");
        this.setDatasetseriesItems(datasetseriesResult);

        // const totalCount = data.result.reduce((acc, curr) => +(curr.count) + acc, 0);
        this.setPageCount(
          Math.ceil(counts.total / this.getLimit)
        );
        this.$Progress.finish();
        this.$nextTick(() => {
          $('[data-toggle="tooltip"]').tooltip({
            container: "body",
          });
        });
      } catch (error) {
        this.$Progress.fail();
        console.error(error)
      } finally {
        // Always reset loading state
        this.$store.dispatch('datasets/setLoading', false);
      }
      this.$root.$emit('contentLoaded');
    },
    handleExport(data) {
      console.log('Data from modal:', data)
      // Example: make API call here
      // axios.post('/api/export', data)
    },
  },
  watch: {
    /**
     * @description Watcher for active facets
     */
    // eslint-disable-next-line object-shorthand
    facets: {
      handler(facets) {
        this.setFacets(facets);
      },
      deep: true,
    },
    // eslint-disable-next-line object-shorthand
    page(pageStr) {
      const page = parseInt(pageStr, 10);
      if (page > 0) this.setPage(page);
      else this.setPage(1);
    },
    dataScope: {
      handler() {
        this.initDataScope();
      },
      deep: true,
    },
    // Watch for changes in route query parameters that affect search results
    '$route.query': {
      handler(newQuery, oldQuery) {
        const relevantParams = ['fields', 'query', 'minDate', 'maxDate', 'dateType', 'maxScoring', 'page', 'dataScope', 'hvdCategory', 'country'];
        const hasRelevantChange = relevantParams.some(param =>
          (newQuery[param] || [])?.toString() !== (oldQuery[param] || [])?.toString()
        );

        if (hasRelevantChange) {
          this.$nextTick(() => {
            this.loadData();
          });
        }
      },
      deep: true
    }
  },
  created() {
    this.$Progress.start();

    this.initDataScope();
    this.initLimit();
    this.initSort();
    this.initPage();
    this.initFacetOperator();
    this.initFacetGroupOperator();
    this.initDataServices();
    this.initMaxScoring();
    this.initFacets();

    this.$nextTick(() => {
      this.loadData();
    });

  },
  mounted() {
    // This is supposed to fix the browser issue (https://gitlab.fokus.fraunhofer.de/piveau/organisation/piveau-scrum-board/-/issues/2344)
    if (this.$route.query.refresh === "true") {
      this.$nextTick(() => {
        this.loadData();
      });
    }
  },
  beforeDestroy() {
    $(".tooltip").remove();
  },
};
</script>


<style lang="scss" scoped>
.dataset-info-box:hover {
  box-shadow: none !important;
  cursor: pointer;
}

#erdpInfobox {
  display: flex;
  padding: 1.25rem;

  .infoIcon {
    height: 20%;
    width: 60%;
    fill: #175baf;
  }

  border:2px solid #175baf;
}

.ecl-message.ecl-message--info {
  //border-left: 4px solid #0xe47cb !important;
  border-radius: 4px 0 0 4px;
  border: none;
  background-color: #f3f6fc;
}

.alert-primary {
  color: #042648;
  background-color: #cddbe8;
  border-color: #baccdf;
}

.content {
  padding: 30px 30px 0 30px;
  // margin-top: 15px;
  margin-bottom: 15px;
  background-color: white;
}

.router-link-active {
  color: #175baf !important;
  border: none !important;
  border-bottom: 2px solid #175baf !important;
}

.router-link-inactive {
  color: rgba(0, 0, 0, 0.7);
  border: none !important;

  &:hover {
    color: #175baf;
  }
}

.material-icons.small-icon {
  font-size: 20px;
}

@media screen and (min-width: 768px) {
  #erdpInfobox {
    margin-left: 15px;
  }

  #datasetFacets {
    display: block;
  }
}

@media screen and (max-width: 767px) {

  .datasets {
    padding-top: 5px;
  }

}
</style>
